import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as workflowsLib from '@debbie/cortex/dist/api/workflows.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { workflowsEntity } from '@debbie/cortex/dist/workflows/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../utils/errors.js';
import Button from '../Button.js';
import Edit from '../Icons/EditText.js';
import { ArrowLeft } from '../Icons/index.js';
import Input from '../Input.js';
import Modal from '../Modal.js';
import { Section } from '../Panel.js';
import SearchInput from '../SearchInput.js';
const WorkflowInfo = (props) => {
    const workflow = props.workflow;
    const lang = useSelector((s) => s.lang);
    const endReasonsLoadable = useEndReasons();
    const endReasons = h.hasData(endReasonsLoadable)
        ? endReasonsLoadable.data
        : [];
    const [editInfoModalOpen, setEditInfoModalOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [noDebtEndReasonId, setNoDebtEndReasonId] = useState(null);
    useEffect(() => {
        setTitle(workflow.title);
        setDescription(workflow.description);
        setNoDebtEndReasonId(workflow.settings.noDebtEndReasonId || null);
    }, [props.workflow]);
    const saveMutation = useMutation(async (updateWorkflow) => {
        await workflowsLib.update(workflow.workflowId, {
            title,
            description,
            settings: {
                noDebtEndReasonId,
            },
            ...updateWorkflow,
        });
        q.invalidate(keys.write.modify(workflowsEntity, workflow.workflowId));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.workflow);
        },
    });
    const deleteMutation = useMutation(async () => {
        await workflowsLib.del(workflow.workflowId);
        q.invalidate(keys.write.modify(workflowsEntity, workflow.workflowId));
    }, {
        onSuccess: () => {
            c.redirect.redirect('/settings/workflows');
        },
        onError: (err) => {
            errorNotification(lang, err, 'delete', lang.errorEntities.workflow);
        },
    });
    const duplicateMutation = useMutation(async () => {
        const newWorkflow = await workflowsLib.duplicateWorkflow(workflow.workflowId);
        q.invalidate(keys.write.create(workflowsEntity));
        c.redirect.redirect(`/workflows/${newWorkflow.workflowId}`);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.workflow);
        },
    });
    const save = (updateWorkflow) => {
        saveMutation.mutate(updateWorkflow);
    };
    const selectedNoDebtEndReason = endReasons.find((endReason) => endReason.id === noDebtEndReasonId);
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", { style: {
                cursor: 'pointer',
            } },
            React.createElement("span", { onClick: () => c.redirect.redirect('/settings/workflows') },
                React.createElement(ArrowLeft, null),
                " ",
                title || workflow.title),
            ' ',
            React.createElement(Edit, { onClick: () => setEditInfoModalOpen(!editInfoModalOpen) })),
        editInfoModalOpen && (React.createElement(Modal, { onToggle: () => setEditInfoModalOpen(!editInfoModalOpen), header: lang.workflows.infoModalHeading, maxWidth: "800px" },
            React.createElement(Section, { header: lang.workflows.title },
                React.createElement(Input, { placeholder: lang.workflows.title, onChange: (e) => setTitle(e.target.value), value: title, onSubmit: props.editable && title !== workflow.title
                        ? () => save()
                        : undefined, disabled: !props.editable }),
                React.createElement(Input, { placeholder: lang.workflows.description, onChange: (e) => setDescription(e.target.value), value: description, onSubmit: props.editable && description !== workflow.description
                        ? () => save()
                        : undefined, disabled: !props.editable })),
            React.createElement(Section, { header: lang.workflows.endCaseIfThereIsNoDebt, description: lang.workflows.endCaseIfThereIsNoDebtDesc },
                React.createElement(SearchInput, { placeholder: lang.workflows.selectEndReason, onSelect: (endReasonId) => {
                        setNoDebtEndReasonId(endReasonId);
                        save({
                            settings: {
                                noDebtEndReasonId: endReasonId,
                            },
                        });
                    }, onRemoveStatic: () => {
                        setNoDebtEndReasonId(null);
                        save({
                            settings: { noDebtEndReasonId: null },
                        });
                    }, forceOpen: true, static: selectedNoDebtEndReason
                        ? lang.endReason[selectedNoDebtEndReason.handle] || selectedNoDebtEndReason.label
                        : undefined, searchAll: (q) => {
                        const r = endReasons.map((endReason) => ({
                            heading: lang.endReason[endReason.handle] ||
                                endReason.label,
                            key: endReason.id,
                            returnData: endReason.id,
                        }));
                        if (!q) {
                            return r;
                        }
                        return r.filter((er) => JSON.stringify(er).toLocaleLowerCase().indexOf(q) !== -1);
                    } })),
            React.createElement(Section, { header: lang.workflows.duplicateWorkflow },
                React.createElement(Button, { theme: "secondary", size: "small", loading: duplicateMutation.isLoading, onClick: () => duplicateMutation.mutate() }, lang.workflows.duplicateWorkflow)),
            React.createElement(Section, { header: lang.workflows.deleteWorkflow },
                React.createElement(Button, { theme: "dangerous", size: "small", loading: deleteMutation.isLoading, onClick: () => {
                        if (confirm(lang.workflows.deleteWorkflowConfirm)) {
                            deleteMutation.mutate();
                        }
                    } }, lang.workflows.deleteWorkflow))))));
};
export default WorkflowInfo;
//# sourceMappingURL=WorkflowInfo.js.map